import { render } from "./OurAdvantages.vue?vue&type=template&id=8d613e74&scoped=true"
import script from "./OurAdvantages.vue?vue&type=script&lang=js"
export * from "./OurAdvantages.vue?vue&type=script&lang=js"

import "./OurAdvantages.vue?vue&type=style&index=0&id=8d613e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d613e74"]])

export default __exports__